import React, { useEffect, useState, Fragment, useRef } from "react";
import Api from "../../../ApiServices/MasterServices";

import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { accountSchema } from "../../../schemas";
import { FaCalendarWeek, FaCheckCircle, FaPauseCircle, FaPlayCircle, FaSave, FaSpinner, FaTimesCircle } from "react-icons/fa";
// import { toast } from "react-toast";
import toast from 'react-hot-toast';

import { Dialog, Combobox, Menu, DialogPanel, DialogTitle, Transition, TransitionChild, Switch, DialogBackdrop } from '@headlessui/react'
import { ArrowRightIcon, BoldIcon, BoltIcon, CalendarIcon, CheckIcon, Cog8ToothIcon, CommandLineIcon, PlayCircleIcon, PlusIcon, TicketIcon, TrashIcon, XMarkIcon } from '@heroicons/react/24/outline'
import Select from "react-select";
import Editor from '@monaco-editor/react';
import LoadingButton from "../../../components/LoadingButton";
import Tooltip from "../../../components/Tooltip";

const initialValues = {
  acc_id: 0,
  acc_no: "",
  acc_name: "",
  acc_type: "", //MASTER
  acc_suffix: "",
  acc_is_banned: "", //false,
  acc_copy_close_trades: "", //true,
  acc_copy_stop_trading: "", //true,
  acc_is_active: "", //true
  fk_master_id: 0,
  acc_multiplier: 0,
  acc_risktype: "",
};

const people = [
  { name: 'Lindsay Walton', title: 'Front-end Developer', email: 'lindsay.walton@example.com', role: 'Member' },
  // More people...
]

const Home = () => {

  const pages = [{ title: "Dashboard", href: "/" }];

  const [acc_id, setAccId] = useState(0);
  const [isSaveBtnApiCall, setIsSaveBtnApiCall] = useState(false);
  const [openAddAccount, setOpenAddAccount] = useState(false);
  const [openAddAccountAcc, setOpenAddAccountAcc] = useState(false);
  const [masterAccounts, setMasterAccount] = useState([]);
  const [slaveAccounts, setSlaveAccount] = useState([]);
  const [formAccount, setFormAccount] = useState(initialValues);
  const [configData, setConfigData] = useState("");
  const [currentSlaveConnector, setCurrentSlaveConnector] = useState(-1);
  const [open, setOpen] = useState(false);
  const [currentSlaveConfig, setCurrentSlaveConfig] = useState({
    msm_id: 0,
    fk_primary_slave_id: 0,
    fk_secondary_master_id: 0,
    msm_multiplier: 0,
    msm_risktype: "",
    msm_config: "{}",
  });
  const editorRef = useRef(null);

  const [currentDateRangeAccount, setCurrentDateRangeAccount] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const handleConfirm = () => {
    console.log('From Date:', fromDate);
    console.log('To Date:', toDate);

    // setOpen(false);
    // setCurrentDateRangeAccount(null);

    if (currentDateRangeAccount && (fromDate && toDate)) {
      const payload = {
        acc_no: currentDateRangeAccount || 0,
        from_date: fromDate || null,
        to_date: toDate || null,
      };

      Api.updateDateRange(payload)
        .then((response) => {
          if (response.data.status) {
            toast.success(response.data.message);
            setOpen(false);
            setCurrentDateRangeAccount(null);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          console.error('Error updating date range:', error);
          toast.error('Failed to update date range');
          setOpen(false);
          setCurrentDateRangeAccount(null);
        });
    } else {
      toast.error("Please select date range");
    }

  };

  const handleConfirmAll = () => {
    if (currentDateRangeAccount) {
      const payload = {
        acc_no: currentDateRangeAccount || 0,
        from_date: null,
        to_date: null,
      };

      Api.updateDateRange(payload)
        .then((response) => {
          if (response.data.status) {
            toast.success(response.data.message);
            setOpen(false);
            setCurrentDateRangeAccount(null);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          console.error('Error updating date range:', error);
          toast.error('Failed to update date range');
          setOpen(false);
          setCurrentDateRangeAccount(null);
        });
    }
  };


  const getSMAcc = async (type) => {
    const getData = await Api.getSlaveMastersAcc(type);
    return getData;
  }

  const setMasterAcc = async () => {
    const resp = await getSMAcc("MASTER");
    if (resp.data.status && resp.data.data.length > 0) {
      setMasterAccount(resp.data.data);
    }
  }

  const setSlaveAcc = async () => {
    const resp = await getSMAcc("SLAVE");
    if (resp.status && resp.data.data.length > 0) {
      setSlaveAccount(resp.data.data);
    }
  }

  useEffect(() => {
    const fetchData = () => {
      setMasterAcc();
      setSlaveAcc();
    };

    fetchData(); // Call on first load

    const interval = setInterval(fetchData, 5000); // Call every 5 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  const handleEditGroup = (data) => {
    console.log(data);
    setFormAccount({
      acc_id: data?.acc_id,
      acc_no: data?.acc_no,
      acc_name: data?.acc_name,
      acc_type: data?.acc_type, //MASTER
      acc_suffix: data?.acc_suffix,
      acc_is_banned: data?.acc_is_banned, //false,
      acc_copy_close_trades: data?.acc_copy_close_trades, //true,
      acc_copy_stop_trading: data?.acc_copy_stop_trading, //true,
      acc_is_active: data?.acc_is_active, //true
      acc_config: data?.acc_config ? data?.acc_config : "{}",
      fk_master_id: data?.fk_master_id,
      acc_multiplier: data?.acc_multiplier,
      acc_risktype: data?.acc_risktype,
    });
    setAccId(data?.acc_id);
    setOpenAddAccount(true);
    /* if (data?.acc_config != null) {
      setConfigData(JSON.stringify(JSON.parse(data?.acc_config), null, 2));
    } */
  }

  const handleToggleIsTradeOpen = async (id, status) => {
    const payload = { acc_id: id, acc_copy_close_trades: status };
    const getResp = await Api.updateAccounts(payload);
    if (getResp.data.status) {
      setMasterAcc();
      setSlaveAcc();
    }
  }

  const handleToggleStopTrading = async (id, status) => {
    const payload = { acc_id: id, acc_copy_stop_trading: status };
    const getResp = await Api.updateAccounts(payload);
    if (getResp.data.status) {
      setMasterAcc();
      setSlaveAcc();
    }
  }

  const handleToggleTP = async (id, status) => {
    const payload = { acc_id: id, acc_tp: status };
    const getResp = await Api.updateAccounts(payload);
    if (getResp.data.status) {
      setMasterAcc();
      setSlaveAcc();
    }
  }

  const handleDeleteAcc = async (id, status) => {
    const payload = { acc_id: id, acc_is_delete: status };
    // console.log(payload);
    const getResp = await Api.updateAccounts(payload);
    if (getResp.data.status) {
      setMasterAcc();
      setSlaveAcc();
    }
  }

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: formAccount,
      validationSchema: accountSchema,
      onSubmit: async (values, action) => {

        let body = {};

        if (values.acc_type == "MASTER" || formAccount.acc_type == "MASTER") {
          body = {
            acc_id: acc_id ? acc_id : 0,
            acc_name: values.acc_name || ""
          }
        } else {
          body = {
            acc_id: acc_id ? acc_id : 0,
            acc_name: values.acc_name || "",
            acc_suffix: values.acc_suffix || "",
            acc_type: values.acc_type,
            acc_config: configData ? configData : "{}",
            fk_master_id: values.fk_master_id ? parseInt(values.fk_master_id) : (masterAccounts && masterAccounts.length > 0 ? masterAccounts?.[0].acc_id : null),
            acc_multiplier: values.acc_multiplier ? parseFloat(values.acc_multiplier) : 0,
            acc_risktype: values.acc_risktype || "",
          }

          /* if(values.fk_master_id == null){
            alert("Select Master Copier")
          } */
        }

        console.log(body);


        const res = await Api.updateAccounts(body);

        if (res.data.status) {
          setMasterAcc();
          setSlaveAcc();
          setOpenAddAccount(false);
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }


      },
    });

  const handleEditorDidMount = (editor, monaco) => {
    editorRef.current = editor;
    editor.onDidChangeModelContent(() => {
      setConfigData(editor.getValue());
    });
  }

  const handleMasterCopier = (data) => {
    // setCurrentSlaveConnector(data.acc_id);
  }

  const handleSingleSave = async (data) => {
    console.log({ data, currentSlaveConfig });

    let body = {
      msm_id: currentSlaveConfig?.msm_id || 0,
      fk_primary_slave_id: Number(currentSlaveConfig?.fk_primary_slave_id),
      fk_secondary_master_id: Number(currentSlaveConfig?.fk_secondary_master_id),
      msm_multiplier: currentSlaveConfig?.msm_multiplier,
      msm_risktype: currentSlaveConfig?.msm_risktype,
      msm_config: currentSlaveConfig?.msm_config || "{}",
    };

    const res = await Api.createMasterSlaveMapping(body);

    if (res.data.status) {
      toast.success(res.data.message);
      setCurrentSlaveConnector(-1)
      setMasterAcc();
      setSlaveAcc();
      setCurrentSlaveConfig({
        msm_id: 0,
        fk_primary_slave_id: 0,
        fk_secondary_master_id: 0,
        msm_multiplier: 0,
        msm_risktype: "",
        msm_config: "{}",
      });
      setConfigData("");
    } else {
      toast.error(res.data.message);
    }

  }


  return (
    <div>

      {/* sm:grid-cols-2 lg:grid-cols-3 */}
      <div className="grid grid-cols-7 gap-4 pb-4 mb-2">

        {/* Master Account */}
        <div className='md:col-span-3 col-span-7'>
          <div className="overflow-hidden bg-[#151515] shadow sm:rounded-lg mt-5">
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-ms font-medium leading-6 text-pink-500">Master Account</h3>
            </div>
            <div className="border-t border-gray-800 p-4">

              {/* NEW */}
              <table className="min-w-full divide-y divide-gray-800">
                <thead>
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200 sm:pl-0">
                      Account Info
                    </th>
                    <th
                      scope="col"
                      className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-200 lg:table-cell"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-800 bg-[#151515]">
                  {masterAccounts.map((account, index) => (
                    <tr key={index}>
                      <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-200 sm:w-auto sm:max-w-none sm:pl-0">

                        {account.acc_no}
                        <span className="ml-2 inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                          {account.acc_name || "UNKNOWN"}
                        </span>

                        <table className="text-gray-500 mt-2">
                          <tr>Current P&L: {account?.acc_current_pnl ? account?.acc_current_pnl : "-"}</tr>
                          <tr>Total Positions: {account?.acc_total_positions ? account?.acc_total_positions : "-"}</tr>
                          <tr>Balance: {account?.acc_balance ? account?.acc_balance : "-"}</tr>
                          <tr>Lots: {account?.acc_lots ? account?.acc_lots : "-"}</tr>
                        </table>

                        <dl className="font-normal lg:hidden">

                          <div className="flex justify-between mt-4">
                            <Tooltip message={`Close Trade - (Click To ${account?.acc_copy_close_trades ? 'Close' : 'Open'})`}>
                              <button
                                onClick={(e) => {
                                  const confirmation = window.confirm(
                                    `Are you sure you want to ${account?.acc_copy_close_trades ? 'close' : 'open'} the trade?`
                                  );
                                  if (confirmation) {
                                    handleToggleIsTradeOpen(account?.acc_id, !account?.acc_copy_close_trades);
                                  }
                                }}
                                type="button"
                                className={` ${!account?.acc_copy_close_trades ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 `}
                              >
                                {account?.acc_copy_close_trades ? (
                                  <FaTimesCircle aria-hidden="true" className="size-5" />
                                ) : (
                                  <FaCheckCircle aria-hidden="true" className="size-5" />
                                )}
                              </button>
                            </Tooltip>

                            <Tooltip message={`Stop Trading - (Click To ${account?.acc_copy_stop_trading ? 'Stop' : 'Start'})`}>
                              <button
                                onClick={(e) => {
                                  const confirmation = window.confirm(
                                    `Are you sure you want to ${account?.acc_copy_stop_trading ? 'stop' : 'start'} the trading?`
                                  );
                                  if (confirmation) {
                                    handleToggleStopTrading(account?.acc_id, !account?.acc_copy_stop_trading);
                                  }
                                  // handleToggleStopTrading(account?.acc_id, !account?.acc_copy_stop_trading)
                                }}
                                type="button"
                                className={` ${!account?.acc_copy_stop_trading ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-`}
                              >
                                {account?.acc_copy_stop_trading ? (
                                  <FaPauseCircle aria-hidden="true" className="size-5" />
                                ) : (
                                  <FaPlayCircle aria-hidden="true" className="size-5" />
                                )}
                              </button>
                            </Tooltip>

                            <Tooltip message={`TP - (Click To ${account?.acc_tp ? 'Stop' : 'Start'})`}>
                              <button
                                onClick={(e) => {
                                  const confirmation = window.confirm(
                                    `Are you sure you want to ${account?.acc_tp ? 'stop' : 'start'} the TP?`
                                  );
                                  if (confirmation) {
                                    handleToggleTP(account?.acc_id, !account?.acc_tp);
                                  }
                                }}
                                type="button"
                                className={` ${account?.acc_tp ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-`}
                              >
                                <BoltIcon aria-hidden="true" className="size-5" />
                              </button>
                            </Tooltip>

                            <button
                              onClick={(e) => {
                                const confirmation = window.confirm(
                                  `Are you sure you want to delete account?`
                                );
                                if (confirmation) {
                                  handleDeleteAcc(account?.acc_id, !account?.acc_is_delete);
                                }
                                // handleToggleStopTrading(account?.acc_id, !account?.acc_copy_stop_trading)
                              }}
                              type="button"
                              className="rounded-full bg-red-600 p-1.5 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                            >
                              <TrashIcon aria-hidden="true" className="size-5" />
                            </button>
                          </div>

                        </dl>
                      </td>

                      <td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">

                        <div className="flex gap-1">

                          <Tooltip message="Manage">
                            <button
                              onClick={(e) => {
                                setFormAccount(initialValues)
                                handleEditGroup(account)
                              }}
                              type="button"
                              className="rounded-full bg-indigo-600 p-1.5 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                              <Cog8ToothIcon aria-hidden="true" className="size-5" />
                            </button>
                          </Tooltip>

                          <Tooltip message={`Close Trade - (Click To ${account?.acc_copy_close_trades ? 'Close' : 'Open'})`}>
                            <button
                              onClick={(e) => {
                                const confirmation = window.confirm(
                                  `Are you sure you want to ${account?.acc_copy_close_trades ? 'close' : 'open'} the trade?`
                                );
                                if (confirmation) {
                                  handleToggleIsTradeOpen(account?.acc_id, !account?.acc_copy_close_trades);
                                }
                              }}
                              type="button"
                              className={` ${!account?.acc_copy_close_trades ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 `}
                            >
                              {account?.acc_copy_close_trades ? (
                                <FaTimesCircle aria-hidden="true" className="size-5" />
                              ) : (
                                <FaCheckCircle aria-hidden="true" className="size-5" />
                              )}
                            </button>
                          </Tooltip>

                          <Tooltip message={`Stop Trading - (Click To ${account?.acc_copy_stop_trading ? 'Stop' : 'Start'})`}>
                            <button
                              onClick={(e) => {
                                const confirmation = window.confirm(
                                  `Are you sure you want to ${account?.acc_copy_stop_trading ? 'stop' : 'start'} the trading?`
                                );
                                if (confirmation) {
                                  handleToggleStopTrading(account?.acc_id, !account?.acc_copy_stop_trading);
                                }
                                // handleToggleStopTrading(account?.acc_id, !account?.acc_copy_stop_trading)
                              }}
                              type="button"
                              className={` ${!account?.acc_copy_stop_trading ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-`}
                            >
                              {account?.acc_copy_stop_trading ? (
                                <FaPauseCircle aria-hidden="true" className="size-5" />
                              ) : (
                                <FaPlayCircle aria-hidden="true" className="size-5" />
                              )}
                            </button>
                          </Tooltip>

                          <Tooltip message={`TP - (Click To ${account?.acc_tp ? 'Stop' : 'Start'})`}>
                            <button
                              onClick={(e) => {
                                const confirmation = window.confirm(
                                  `Are you sure you want to ${account?.acc_tp ? 'stop' : 'start'} the TP?`
                                );
                                if (confirmation) {
                                  handleToggleTP(account?.acc_id, !account?.acc_tp);
                                }
                              }}
                              type="button"
                              className={` ${account?.acc_tp ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-`}
                            >
                              <BoltIcon aria-hidden="true" className="size-5" />
                            </button>
                          </Tooltip>

                          <button
                            onClick={(e) => {
                              const confirmation = window.confirm(
                                `Are you sure you want to delete account?`
                              );
                              if (confirmation) {
                                handleDeleteAcc(account?.acc_id, !account?.acc_is_delete);
                              }
                              // handleToggleStopTrading(account?.acc_id, !account?.acc_copy_stop_trading)
                            }}
                            type="button"
                            className="rounded-full bg-red-600 p-1.5 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                          >
                            <TrashIcon aria-hidden="true" className="size-5" />
                          </button>
                        </div>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>


        {/* Slace Account */}
        <div className='md:col-span-4 col-span-7'>
          <div className="overflow-hidden bg-[#151515] shadow sm:rounded-lg mt-5">
            <div className="px-4 py-5 sm:px-6">
              <h3 className="text-ms font-medium leading-6 text-pink-500">Slave Account</h3>
            </div>
            <div className="border-t border-gray-800 p-4">

              <table className="min-w-full divide-y divide-gray-800">
                <thead>
                  <tr>
                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200 sm:pl-0">
                      Account Info
                    </th>
                    <th
                      scope="col"
                      className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-200 lg:table-cell"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-800 bg-[#151515]">
                  {slaveAccounts.map((account, index) => (
                    <tr key={index}>
                      <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-200 sm:w-auto sm:max-w-none sm:pl-0">

                        {account.acc_no}
                        <span className="ml-2 inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                          {account.acc_name || "UNKNOWN"}
                        </span>

                        {/* {
                          account?.acc_from_date && account?.acc_to_date ? (
                            <span onClick={(e) => {
                              setCurrentDateRangeAccount(account.acc_no);
                              setFromDate(account?.acc_from_date || null);
                              setToDate(account?.acc_to_date || null);
                              setOpen(!open);
                            }} className="cursor-pointer ml-2 inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/20">
                              <FaCalendarWeek aria-hidden="true" className="size-4" />
                              <span className="ml-1">
                                From: {account?.acc_from_date} # To: {account?.acc_to_date}
                              </span>
                            </span>
                          ) : null
                        } */}

                        <table className="text-gray-500 mt-2">
                          <tr>Current P&L: {account?.acc_current_pnl ? account?.acc_current_pnl : "-"}</tr>
                          <tr>Total Positions: {account?.acc_total_positions ? account?.acc_total_positions : "-"}</tr>
                          <tr>Balance: {account?.acc_balance ? account?.acc_balance : "-"}</tr>
                          <tr>Lots: {account?.acc_lots ? account?.acc_lots : "-"}</tr>
                        </table>

                        <div className="gap-1 mt-2">
                          <div className="bg-[#222] rounded-md shadow">
                            <button
                              className="w-full text-left px-4 py-2 text-sm font-medium text-gray-200 bg-[#333] rounded-t-md hover:bg-[#444] focus:outline-none"
                              onClick={() => {
                                const accordion = document.getElementById(`history-${index}`);
                                accordion.style.display = accordion.style.display === "none" ? "block" : "none";
                              }}
                            >
                              History
                              {
                                account?.acc_from_date && account?.acc_to_date ? (
                                  <span className="cursor-pointer ml-2 inline-flex items-center rounded-md  px-2 py-1 text-xs font-medium text-gray-400 ring-1 ring-inset ring-blue-600/20">
                                    <FaCalendarWeek aria-hidden="true" className="size-4" />
                                    <span className="ml-1">
                                      From: {account?.acc_from_date} # To: {account?.acc_to_date}
                                    </span>
                                  </span>
                                ) : null
                              }

                              {/* onClick={(e) => {
                                setCurrentDateRangeAccount(account.acc_no);
                                setFromDate(account?.acc_from_date || null);
                                setToDate(account?.acc_to_date || null);
                                setOpen(!open);
                              }} */}

                            </button>
                            <div id={`history-${index}`} style={{ display: "none" }} className="p-4 text-gray-400">
                              <table className="min-w-full divide-y divide-gray-800">
                                <tbody className="divide-y divide-gray-800 ">
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Total Profit</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_total_profit || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Total Commissions</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_total_commissions || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Net Profit</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_net_profit || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Total Buy Trades</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_total_buy_trades || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Total Sell Trades</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_total_sell_trades || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Total Trades</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_total_trades || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Total Buy Lots</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_total_buy_lots || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Total Sell Lots</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_total_sell_lots || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">Total Lots</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_total_lots || "-"}</td>
                                  </tr>
                                  <tr>
                                    <td className="px-1 py-1 text-sm text-gray-500">ROI</td>
                                    <td className="px-1 py-1 text-sm text-gray-500">{account?.acc_roi || "-"}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <div className="mt-4"></div>

                        <dl className="font-normal lg:hidden">

                          <div className="flex justify-between mt-4">
                            <Tooltip message="Manage">
                              <button
                                onClick={(e) => {
                                  setFormAccount(initialValues)
                                  handleEditGroup(account)
                                }}
                                type="button"
                                className="rounded-full bg-indigo-600 p-1.5 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                              >
                                <Cog8ToothIcon aria-hidden="true" className="size-5" />
                              </button>
                            </Tooltip>

                            <Tooltip message={`Close Trade - (Click To ${account?.acc_copy_close_trades ? 'Close' : 'Open'})`}>
                              <button
                                onClick={(e) => {
                                  const confirmation = window.confirm(
                                    `Are you sure you want to ${account?.acc_copy_close_trades ? 'close' : 'open'} the trade?`
                                  );
                                  if (confirmation) {
                                    handleToggleIsTradeOpen(account?.acc_id, !account?.acc_copy_close_trades);
                                  }
                                }}
                                type="button"
                                className={` ${!account?.acc_copy_close_trades ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 `}
                              >
                                {account?.acc_copy_close_trades ? (
                                  <FaTimesCircle aria-hidden="true" className="size-5" />
                                ) : (
                                  <FaCheckCircle aria-hidden="true" className="size-5" />
                                )}
                              </button>
                            </Tooltip>

                            <Tooltip message={`Stop Trading - (Click To ${account?.acc_copy_stop_trading ? 'Stop' : 'Start'})`}>
                              <button
                                onClick={(e) => {
                                  const confirmation = window.confirm(
                                    `Are you sure you want to ${account?.acc_copy_stop_trading ? 'stop' : 'start'} the trading?`
                                  );
                                  if (confirmation) {
                                    handleToggleStopTrading(account?.acc_id, !account?.acc_copy_stop_trading);
                                  }
                                }}
                                type="button"
                                className={` ${!account?.acc_copy_stop_trading ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-`}
                              >
                                {account?.acc_copy_stop_trading ? (
                                  <FaPauseCircle aria-hidden="true" className="size-5" />
                                ) : (
                                  <FaPlayCircle aria-hidden="true" className="size-5" />
                                )}
                              </button>
                            </Tooltip>

                            <Tooltip message={`TP - (Click To ${account?.acc_tp ? 'Stop' : 'Start'})`}>
                              <button
                                onClick={(e) => {
                                  const confirmation = window.confirm(
                                    `Are you sure you want to ${account?.acc_tp ? 'stop' : 'start'} the TP?`
                                  );
                                  if (confirmation) {
                                    handleToggleTP(account?.acc_id, !account?.acc_tp);
                                  }
                                }}
                                type="button"
                                className={` ${account?.acc_tp ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-`}
                              >
                                <BoltIcon aria-hidden="true" className="size-5" />
                              </button>
                            </Tooltip>

                            <button
                              onClick={(e) => {
                                const confirmation = window.confirm(
                                  `Are you sure you want to delete account?`
                                );
                                if (confirmation) {
                                  handleDeleteAcc(account?.acc_id, !account?.acc_is_delete);
                                }
                              }}
                              type="button"
                              className="rounded-full bg-red-600 p-1.5 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                            >
                              <TrashIcon aria-hidden="true" className="size-5" />
                            </button>

                            <button
                              onClick={(e) => {
                                setCurrentDateRangeAccount(account.acc_no);
                                setFromDate(account?.acc_from_date || null);
                                setToDate(account?.acc_to_date || null);
                                setOpen(!open);
                              }}
                              type="button"
                              className="rounded-full bg-red-600 p-1.5 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                            >
                              <CalendarIcon aria-hidden="true" className="size-5" />
                            </button>

                          </div>

                        </dl>
                      </td>

                      <td className="hidden px-3 py-4 text-sm text-gray-500 lg:table-cell">

                        <div className="flex gap-1">
                          <Tooltip message="Manage">
                            <button
                              onClick={(e) => {
                                setFormAccount(initialValues)
                                handleEditGroup(account)
                              }}
                              type="button"
                              className="rounded-full bg-indigo-600 p-1.5 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                              <Cog8ToothIcon aria-hidden="true" className="size-5" />
                            </button>
                          </Tooltip>

                          <Tooltip message={`Close Trade - (Click To ${account?.acc_copy_close_trades ? 'Close' : 'Open'})`}>
                            <button
                              onClick={(e) => {
                                const confirmation = window.confirm(
                                  `Are you sure you want to ${account?.acc_copy_close_trades ? 'close' : 'open'} the trade?`
                                );
                                if (confirmation) {
                                  handleToggleIsTradeOpen(account?.acc_id, !account?.acc_copy_close_trades);
                                }
                              }}
                              type="button"
                              className={` ${!account?.acc_copy_close_trades ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 `}
                            >
                              {account?.acc_copy_close_trades ? (
                                <FaTimesCircle aria-hidden="true" className="size-5" />
                              ) : (
                                <FaCheckCircle aria-hidden="true" className="size-5" />
                              )}
                            </button>
                          </Tooltip>

                          <Tooltip message={`Stop Trading - (Click To ${account?.acc_copy_stop_trading ? 'Stop' : 'Start'})`}>
                            <button
                              onClick={(e) => {
                                const confirmation = window.confirm(
                                  `Are you sure you want to ${account?.acc_copy_stop_trading ? 'stop' : 'start'} the trading?`
                                );
                                if (confirmation) {
                                  handleToggleStopTrading(account?.acc_id, !account?.acc_copy_stop_trading);
                                }
                              }}
                              type="button"
                              className={` ${!account?.acc_copy_stop_trading ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-`}
                            >
                              {account?.acc_copy_stop_trading ? (
                                <FaPauseCircle aria-hidden="true" className="size-5" />
                              ) : (
                                <FaPlayCircle aria-hidden="true" className="size-5" />
                              )}
                            </button>
                          </Tooltip>

                          <Tooltip message={`TP - (Click To ${account?.acc_tp ? 'Stop' : 'Start'})`}>
                            <button
                              onClick={(e) => {
                                const confirmation = window.confirm(
                                  `Are you sure you want to ${account?.acc_tp ? 'stop' : 'start'} the TP?`
                                );
                                if (confirmation) {
                                  handleToggleTP(account?.acc_id, !account?.acc_tp);
                                }
                              }}
                              type="button"
                              className={` ${account?.acc_tp ? 'bg-green-600 hover:bg-green-500' : 'bg-pink-600 hover:bg-pink-500'} rounded-full p-1.5 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-`}
                            >
                              <BoltIcon aria-hidden="true" className="size-5" />
                            </button>
                          </Tooltip>

                          <button
                            onClick={(e) => {
                              const confirmation = window.confirm(
                                `Are you sure you want to delete account?`
                              );
                              if (confirmation) {
                                handleDeleteAcc(account?.acc_id, !account?.acc_is_delete);
                              }
                            }}
                            type="button"
                            className="rounded-full bg-red-600 p-1.5 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                          >
                            <TrashIcon aria-hidden="true" className="size-5" />
                          </button>

                          <button
                            onClick={(e) => {
                              setCurrentDateRangeAccount(account.acc_no);
                              setFromDate(account?.acc_from_date || null);
                              setToDate(account?.acc_to_date || null);
                              setOpen(!open);
                            }}
                            type="button"
                            className="rounded-full bg-red-600 p-1.5 text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                          >
                            <CalendarIcon aria-hidden="true" className="size-5" />
                          </button>

                        </div>

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>

      </div>



      {/* Modal for Acc Account */}
      <Transition show={openAddAccount}>
        <Dialog className="relative z-10" onClose={setOpenAddAccount}>
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 backdrop-blur-sm transition-opacity" />
          </TransitionChild>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <TransitionChild
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <DialogPanel className="relative transform overflow-hidden rounded-lg bg-[#151515] px-2 pb-2 pt-2 text-left shadow-xl transition-all">
                  <div>
                    <div className="mt-2 sm:mt-2">
                      <DialogTitle as="h3" className="text-base text-center border-b border-[#999] font-semibold leading-6 text-gray-200 pb-3">
                        {acc_id > 0 ? 'Update Account #' + (formAccount ? formAccount?.acc_no : "") : 'Manage Account'}
                      </DialogTitle>
                      <div className="mt-2">
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            console.log(e);
                            handleSubmit(e);
                          }}
                          className="flex h-full flex-col"
                        >
                          <div className="h-0 flex-1 overflow-y-auto">
                            <div className="flex flex-1 flex-col justify-between">
                              <div className="p-4 sm:p-6">
                                <div className="mt-2 mb-2 sm:col-span-2 sm:mt-0">
                                  <div>
                                    <label
                                      htmlFor="acc_name"
                                      className="block text-sm font-medium text-gray-200 mt-2 mb-1"
                                    >
                                      Account Name
                                    </label>
                                  </div>
                                  <div className="mt-2 mb-3 sm:col-span-2 sm:mt-0">
                                    <input
                                      value={values.acc_name}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      type="text"
                                      placeholder="Set Account Name"
                                      name="acc_name"
                                      autoComplete="off"
                                      className="text-white bg-[#222] block w-full max-w-lg rounded-md border-[1px] p-2 border-gray-800 shadow-sm focus:border-[1px] focus:border-cyan-500 "
                                    />
                                  </div>
                                </div>


                                {
                                  formAccount.acc_type != "MASTER" && (
                                    <div>
                                      <div className="flex flex-wrap gap-6">
                                        <div className="w-full">
                                          <label htmlFor="acc_suffix" className="block text-sm font-medium text-gray-200 mb-1">
                                            Instrument Match
                                          </label>
                                          <input
                                            value={values.acc_suffix}
                                            defaultValue={values.acc_suffix}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            type="text"
                                            placeholder="Acc Suffix"
                                            name="acc_suffix"
                                            autoComplete="off"
                                            className="text-white bg-[#222] block w-full max-w-lg rounded-md border-[1px] p-2 border-gray-800 shadow-sm focus:border-[1px] focus:border-cyan-500 "
                                          />
                                        </div>

                                      </div>

                                      <div className="mt-2 mb-2 sm:col-span-2 sm:mt-0">
                                        <div>
                                          <label
                                            htmlFor="acc_type"
                                            className="block text-sm font-medium text-gray-200 mt-2 mb-1"
                                          >
                                            Copy From Master Account
                                          </label>
                                        </div>
                                        <div className="mt-2 mb-3 sm:col-span-2 sm:mt-0">
                                          <select
                                            value={values.fk_master_id}
                                            defaultValue={values.fk_master_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            name="fk_master_id"
                                            className="text-white bg-[#222] block w-full max-w-lg rounded-md border-[1px] p-2 border-gray-800 shadow-sm focus:border-[1px] focus:border-cyan-500 "
                                          >
                                            <option value={null}>Select Acc</option>
                                            {masterAccounts.map((data, index) => (
                                              <option key={index} value={data.acc_id}>{data.acc_no} - {data.acc_name}</option>
                                            ))}
                                          </select>
                                        </div>
                                      </div>


                                      <div className="mt-2 mb-2 sm:col-span-2 sm:mt-0">
                                        <div className="w-full">
                                          <label
                                            htmlFor="risk_type"
                                            className="block text-sm font-medium text-gray-200 mt-2 mb-1"
                                          >
                                            Risk Type
                                          </label>
                                        </div>
                                        <div className="mt-2 mb-3 sm:col-span-2 sm:mt-0">
                                          <select
                                            value={values.acc_risktype}
                                            defaultValue={values.acc_risktype}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            name="acc_risktype"
                                            className="text-white bg-[#222] block w-full rounded-md border-[1px] p-2 border-gray-800 shadow-sm focus:border-[1px] focus:border-cyan-500 "
                                          >
                                            <option disabled>Select Risk Type</option>
                                            <option value="Lot_Multiplier">Lot Multiplier</option>
                                            <option value="Risk_Multiplier_By_Balance">Risk Multiplier By Balance</option>
                                            <option value="Risk_Multiplier_By_Free_Margin">Risk Multiplier By Free Margin</option>
                                            <option value="Exact_Lots">Exact Lots</option>
                                          </select>
                                        </div>
                                      </div>


                                      <div className="mt-2 mb-2 sm:col-span-2 sm:mt-0">
                                        <div className="w-full">
                                          <label htmlFor="acc_multiplier" className="block text-sm font-medium text-gray-200 mb-1">
                                            Multiplier
                                          </label>
                                          <input
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.acc_multiplier}
                                            defaultValue={values.acc_multiplier}
                                            type="number"
                                            placeholder="E.g. 2"
                                            name="acc_multiplier"
                                            autoComplete="off"
                                            step={0.1}
                                            className="block w-full rounded-md bg-white/5 px-3 py-1.5 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  )
                                }

                              </div>
                            </div>
                          </div>
                          <div className="flex flex-shrink-0 justify-end px-4 pb-2">
                            <button
                              type="button"
                              className="rounded-md border border-gray-700 bg-[#222222] py-2 px-4 text-sm font-medium text-gray-400 shadow-sm hover:bg-gray-500"
                              onClick={() => {
                                setFormAccount({
                                  acc_id: 0,
                                  acc_no: "",
                                  acc_name: "",
                                  acc_type: "", //MASTER
                                  acc_suffix: "",
                                  acc_is_banned: "", //false,
                                  acc_copy_close_trades: "", //true,
                                  acc_is_active: "", //true
                                  fk_master_id: 0,
                                  msm_multiplier: 0,
                                  msm_risktype: "",
                                });
                                setAccId(null);
                                setConfigData("");
                                setOpenAddAccount(false);
                              }}
                            >
                              Cancel
                            </button>
                            {
                              isSaveBtnApiCall ? (
                                <LoadingButton title=" Saving" />
                              ) : (
                                <button
                                  type="submit"
                                  className="ml-4 inline-flex justify-center rounded-md bbt bg-gradient-to-b bg-[#0172fd] py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-cyan-700"
                                >
                                  {acc_id > 0 ? 'Update' : 'Add'} Account
                                </button>
                              )
                            }
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>



      <Dialog open={open} onClose={setOpen} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-black bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-[#151515] px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >

              <div className="w-full">

                <h2 className="text-lg font-semibold mb-4 text-pink-500">Manage Date Range for #{currentDateRangeAccount}</h2>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-300 mb-1">From:</label>
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="w-full border border-gray-300 rounded px-2 py-1"
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-300 mb-1">To:</label>
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="w-full border border-gray-300 rounded px-2 py-1"
                  />
                </div>

                <div className="flex justify-end gap-2">
                  <button
                    onClick={handleConfirmAll}
                    className="bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-600"
                  >
                    Set All
                  </button>
                  <button
                    onClick={handleConfirm}
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                  >
                    Save & Update
                  </button>
                  <button
                    onClick={(e) => {
                      setOpen(false);
                      setCurrentDateRangeAccount(null);
                    }}
                    className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                </div>

              </div>

            </DialogPanel>
          </div>
        </div>
      </Dialog>


    </div>
  )

}

export default Home